import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "allowHTML", "dangerouslySetInnerHTML", "allowLineFeed"];
import React, { forwardRef } from 'react';
import { spreadDangerousChildren } from "./utils";
export var withInnerHTML = function withInnerHTML(WrappedComponent) {
  return /*#__PURE__*/forwardRef(function (_ref, ref) {
    var children = _ref.children,
      _ref$allowHTML = _ref.allowHTML,
      allowHTML = _ref$allowHTML === void 0 ? true : _ref$allowHTML,
      dangerouslySetInnerHTML = _ref.dangerouslySetInnerHTML,
      _ref$allowLineFeed = _ref.allowLineFeed,
      allowLineFeed = _ref$allowLineFeed === void 0 ? true : _ref$allowLineFeed,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    var Component = WrappedComponent;
    return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
      ref: ref
    }, dangerouslySetInnerHTML ? {
      dangerouslySetInnerHTML: dangerouslySetInnerHTML
    } : spreadDangerousChildren(children, allowHTML, allowLineFeed), {
      "data-t-id": "hocs-withInnerHTML"
    }));
  });
};